import { useCallback, useEffect } from "react";
import { NavigateFunction } from "react-router-dom";
import { SelectionFeature } from "src/js/stores/map/store";
import { useRegionAccess } from "react-migration/lib/util/useRegionAccess";
import { useSelectionHandler } from "../../../selection_types/useSelectionHandler";
import { AssessmentLayerTabUK, AssessmentLayerTabUS } from "../AssessmentTab/types";

interface DetailViewProps {
  detailSelection: SelectionFeature;
  selection: SelectionFeature;
  setSelection(selection?: SelectionFeature): void;
  setDetailSelection(selection?: SelectionFeature): void;
  onBack(): void;
  navigate?: NavigateFunction;
}

export function DetailView({
  detailSelection,
  selection,
  onBack,
  setSelection,
  setDetailSelection,
  navigate,
}: DetailViewProps) {
  const { SelectionDetailView, SelectionHeader, useSelectionOutsideZoomRestriction } =
    useSelectionHandler(detailSelection);

  const { isUS } = useRegionAccess();

  const isOutsideZoomRestrictions = useSelectionOutsideZoomRestriction?.(detailSelection);

  useEffect(() => {
    if (isOutsideZoomRestrictions !== true) return;

    setDetailSelection && setDetailSelection(undefined);
  }, [isOutsideZoomRestrictions, setDetailSelection]);

  const handleSetSelection = useCallback(
    (newSelection: SelectionFeature) => {
      navigate?.(`/assessment/${isUS ? AssessmentLayerTabUS.DETAILS : AssessmentLayerTabUK.DETAILS}`);

      setSelection(newSelection);
      setDetailSelection(undefined);
    },
    [isUS, navigate, setDetailSelection, setSelection]
  );

  if (!SelectionDetailView || !SelectionHeader) return null; // TODO - add a default view

  return (
    <div className="overflow-hidden bg-white border rounded-sm border-border-action print:break-inside-avoid">
      <div className="p-2">
        <SelectionHeader
          selection={detailSelection}
          setSelection={setDetailSelection}
          onHeaderClick={navigate && selection.id !== detailSelection.id ? handleSetSelection : undefined}
        />
      </div>
      <SelectionDetailView
        setDetailSelection={setDetailSelection}
        setSelection={setSelection}
        selection={detailSelection}
        clearSelection={onBack}
        isSummary={false}
      />
    </div>
  );
}
